import { useEffect, useRef, useState } from "react";
import { Icon } from "../ui/Icon";
import { LANGS, setLang, t, useLang } from "../lib/i18n";

/** 🌐 language menu next to the theme switch. Changes the whole UI at once and is remembered per browser. */
export function LangToggle() {
  const lang = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent) => { if (!ref.current?.contains(e.target as Node)) setOpen(false); };
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, [open]);
  const cur = LANGS.find((l) => l.code === lang)!;
  return (
    <div ref={ref} className="relative">
      <button type="button" onClick={() => setOpen((v) => !v)} aria-haspopup="menu" aria-expanded={open} aria-label={t("Tukar bahasa")} title={t("Tukar bahasa")}
        className="flex h-10 items-center gap-1 rounded-full bg-sky-100 px-3 text-sm font-bold text-blue-900 hover:bg-sky-200 md:bg-white/15 md:text-white md:hover:bg-white/25">
        <Icon name="globe" className="h-5 w-5" />
        <span>{cur.short}</span>
      </button>
      {open && (
        <ul role="menu" className="absolute right-0 z-20 mt-2 w-44 md:bottom-full md:left-0 md:right-auto md:mb-2 md:mt-0 overflow-hidden rounded-xl border border-surface-line bg-card py-1 text-brand-ink shadow-lg">
          {LANGS.map((l) => (
            <li key={l.code}>
              <button type="button" role="menuitemradio" aria-checked={l.code === lang}
                onClick={() => { setLang(l.code); setOpen(false); }}
                className={`flex w-full items-center justify-between px-4 py-2 text-left text-sm hover:bg-surface-muted ${l.code === lang ? "font-bold" : ""}`}>
                <span lang={l.code}>{l.label}</span>
                {l.code === lang && <span aria-hidden>✓</span>}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
